import { render, staticRenderFns } from "./SetPortMapping.vue?vue&type=template&id=2f51b899"
import script from "./SetPortMapping.vue?vue&type=script&lang=js"
export * from "./SetPortMapping.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports